import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/auth/AuthProvider";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    // useRef-based one-shot guard (StrictMode-safe)
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        // Clear the fragment from the URL
        window.history.replaceState(null, "", window.location.pathname);
        const user = await refresh();
        navigate("/dashboard", { replace: true, state: { user } });
      } catch (err) {
        setError("We couldn't complete sign-in. Please try again.");
        setTimeout(() => navigate("/", { replace: true }), 2500);
      }
    })();
  }, [navigate, refresh]);

  return (
    <div
      className="min-h-screen bg-[#F4F3EE] text-[#111418] flex items-center justify-center"
      data-testid="auth-callback"
    >
      <div className="max-w-md mx-auto text-center px-6">
        <span className="gp-overline">// Authenticating</span>
        <h1 className="mt-4 font-display text-3xl md:text-4xl font-semibold text-[#111418] leading-tight">
          {error ? "Sign-in failed" : "Bringing you in…"}
        </h1>
        <p className="mt-4 text-[#2C333A] text-[15px] leading-relaxed">
          {error || "Securely exchanging your session with GushPay."}
        </p>
        <div className="mt-6 inline-flex h-1 w-32 bg-[#D3D9DE] overflow-hidden">
          <span
            aria-hidden
            className="block w-1/2 h-full bg-[#0F4C5C] animate-pulse"
          />
        </div>
      </div>
    </div>
  );
}
